import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Notification from 'component/utils/Notification'
import Pagination from 'component/pagination/Pagination'
import { ToastContainer } from 'react-toastify'
import Grid from 'component/utils/Grid'
import screenType from 'component/menuMission/screenType'
import Select from 'react-select'
import { colourStyles } from 'utils/selectStyle'
import Col from 'component/utils/Col'
import OptionsView from 'component/menuMissionView/OptionsView'
import ViewTable from 'component/menuMissionView/ViewTable'
import ViewModal from 'component/menuMissionView/ViewModal'
import UpperFilterForm from 'component/menuMission/UpperFilterForm'
import SideFilterForm from 'component/menuMissionView/SideFilterForm'
import { usePrevProp } from 'utils/hooks'

import * as menuMissionActions from 'action/menuMission'
import * as menuActions from 'action/menu'

import 'styles/overwrittenAndNew/newPageStyle.css'

/**
 * TIP_SHOW of menus
 */
const APP_PERMISSION = 1
const WEB_PERMISSION = 2

const DEFAULT_FILTER_INITIAL_VALUES = {
  genericSearch: '',
  isMission: true,
  isPersonalProfile: true,
  lsCdMenus: [],
}

const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const PAGINATION_OPTIONS = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 30, value: 30 },
  { label: 40, value: 40 },
  { label: 50, value: 50 },
]

const MenuMissionViewContainer = ({
  translate,
  auth: {
    user: { dsToken },
  },
  menuMissions: records,
  fetch,
  pages,
  count,
  current,
  permissions,
  fetchPermissions,
}) => {
  const [filters, setFilters] = useState(DEFAULT_FILTER_INITIAL_VALUES)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [lsDsProfiles, setLsDsProfiles] = useState([])
  const [openViewModal, setOpenViewModal] = useState(null)
  const [showTable, setShowTable] = useState(false)
  const [orderBy, setOrderBy] = useState(true)
  const prevFilters = usePrevProp(filters)
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const prevPagination = usePrevProp(pagination)
  const [firstFetch, setFirstFetch] = useState(true)

  const webPermissions = permissions.filter(
    (p) => p.tipShow === WEB_PERMISSION && p.cdMenu !== 106
  )
  webPermissions.sort((a, b) => {
    if (a.dsMenuParent < b.dsMenuParent) return -1
    if (a.cdMenuParent > b.cdMenuParent) return 1
    return 0
  })

  const appPermissions = permissions.filter((p) => p.tipShow === APP_PERMISSION)
  appPermissions.sort((aa, bb) => {
    if (aa.dsMenuParent < bb.dsMenuParent) return -1
    if (aa.dsMenuParent > bb.dsMenuParent) return 1
    return 0
  })
  /**
   * Did mount
   */
  useEffect(() => {
    fetchPermissions(dsToken)

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    handleFetch()
  }, [orderBy])

  /**
   * When filters change
   */
  useEffect(() => {
    if (!firstFetch) {
      if (filters !== prevFilters) {
        if (pagination.page > 1) {
          setPagination({ ...pagination, page: 1 })
        } else {
          handleFetch()
        }
      }
    }
  }, [filters])

  /**
   * When pagination changes
   */
  useEffect(() => {
    if (!firstFetch) {
      if (pagination !== prevPagination) {
        handleFetch()
      }
    }
  }, [pagination])

  const handleResize = () => {}

  /**
   * Handle data fetch
   */
  const handleFetch = async (reset = false) => {
    handleResize()
    setFirstFetch(false)

    const param = {
      ...filters,
      ...pagination,
    }

    reset && (param.page = 1)

    setShowTable(false)

    await fetch(dsToken, param, orderBy)

    setShowTable(true)
  }

  useEffect(() => {
    fetchPermissions(dsToken)

    handleFetch()
  }, [])

  const handleOrderChange = () => {
    handleFetch()
    setOrderBy(!orderBy)
  }

  /**
   * Render modal to view info about a profile
   */
  const renderViewModal = () => {
    if (!openViewModal) return

    return (
      <ViewModal
        closeModal={() => setOpenViewModal(null)}
        record={openViewModal}
        translate={translate}
      />
    )
  }

  /**
   * Set new filters
   */
  const setValues = (values) => {
    setFilters({ ...filters, ...values, o: Math.random })
  }

  const toggleSideFilter = () => {
    setSideFilterVisible(!sideFilterVisible)
  }

  const renderUpperSection = () => (
    <div className='new-style'>
      <Grid fluid className='new-upper-container'>
        <Col xs={12} md={6}>
          <UpperFilterForm submit={setValues} translate={translate} />
        </Col>
        <Col xs={12} md={6}>
          <OptionsView
            setSideFilterVisible={toggleSideFilter}
            translate={translate}
          />
        </Col>
      </Grid>
    </div>
  )

  /**
   * Render pagination
   */
  const renderPagination = () => (
    <Col className='align-center margin-bottom margin-top-triple new-style-pagination'>
      {!!records.length && pages > 1 && showTable && (
        <Pagination
          count={count}
          current={current}
          getPage={(page) => setPagination({ ...pagination, page })}
          pages={pages}
        />
      )}

      {!!records.length &&
        pages > 1 &&
        showTable &&
        renderPaginationSizeSelect()}
    </Col>
  )

  /**
   * Render pagination size select
   */
  const renderPaginationSizeSelect = () => (
    <div className='pagination-size-selector'>
      <Col xs={6}>{translate('pagination.size.selector')}</Col>
      <Col xs={4}>
        <Select
          classNamePrefix='react-select'
          onChange={(option) =>
            setPagination({ ...pagination, page: 1, size: option.value })
          }
          options={PAGINATION_OPTIONS}
          styles={colourStyles}
          value={PAGINATION_OPTIONS.find((i) => i.value === pagination.size)}
        />
      </Col>
    </div>
  )

  const renderTable = () => {
    const handleOpenViewModal = (record) => {
      const newValues = {
        ...record,
        type: record.dsLdap
          ? screenType.EDIT_PERSONAL_PROFILE_TYPE
          : screenType.EDIT_MISSION_PROFILE_TYPE,
      }

      setOpenViewModal(newValues)
    }

    return records.length ? (
      showTable ? (
        <ViewTable
          handleResize={() => {}}
          lsDsProfiles={lsDsProfiles}
          openViewModal={handleOpenViewModal}
          records={records}
          setLsDsProfiles={setLsDsProfiles}
          translate={translate}
          onOrderChange={handleOrderChange}
          orderBy={orderBy}
        />
      ) : (
        ''
      )
    ) : (
      <Col
        xs={12}
        className='margin-top margin-right'
        style={{ marginLeft: `${sideFilterVisible ? 0.5 : 1}rem` }}
      >
        <Notification
          message={translate('no.data.found')}
          className='notification-warning'
        />
      </Col>
    )
  }

  const renderSideFilterForm = () => {
    if (!sideFilterVisible) return

    const handleSubmitSideFilterForm = (values) => {
      setSideFilterVisible(false)

      setValues(values)
    }

    return (
      <SideFilterForm
        appPermissions={appPermissions}
        initialValues={filters}
        setSideFilterVisible={toggleSideFilter}
        submit={handleSubmitSideFilterForm}
        translate={translate}
        webPermissions={webPermissions}
      />
    )
  }

  return (
    <Fragment>
      <div className='new-style'>
        <ContentHeader>{translate('missionsView.title')}</ContentHeader>

        <div className='padding-bottom new-style-filter'>
          {renderUpperSection()}
        </div>

        <div className='new-style-table'>
          <Grid fluid className='no-padding'>
            <div className='outer-table new-outer-table'>
              <div>{renderTable()}</div>

              {renderPagination()}
            </div>
          </Grid>
        </div>

        {renderViewModal()}

        <ToastContainer newestOnTop />
      </div>

      {renderSideFilterForm()}
    </Fragment>
  )
}

MenuMissionViewContainer.propTypes = {
  translate: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  error: PropTypes.object,
  menuMissions: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  pages: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  permissions: PropTypes.array.isRequired,
  fetchPermissions: PropTypes.func.isRequired,
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({
  menuReducer,
  menuMissionReducer,
  paginateReducer,
}) => ({
  menuMissions: menuMissionReducer.list.records,
  error: menuMissionReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  permissions: menuReducer.permissions,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...menuMissionActions, ...menuActions }, dispatch)

/*
 * Connects component to I18next
 */
const MenuMissionViewTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(MenuMissionViewContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuMissionViewTranslated)

/*
 * Exports as component
 */
export { MenuMissionViewContainer as MenuMissionView }
